import moment from "moment";

export const adjustDateOffset = (date: string) => {
  return moment(date).add(new Date().getTimezoneOffset() / 60, "hour");
};
